/**
 * Opener layout form.
 *
 * Openers are the single-statement slides that anchor a deck — the
 * thesis line plus an optional sub-heading. They render with the
 * Flexcompute + Thread logo lockup baked in. The form exposes the
 * title and the body markup, with a layout hint pointing editors at
 * the ``<h2>`` subtitle convention.
 */

import type { Slide, SlideUpdatePayload } from "../types";
import { CommonSlideFields } from "./CommonSlideFields";
import { LayoutHint } from "./LayoutHint";
import { TextArea } from "./FormPrimitives";

interface OpenerFormProps {
  draft: Slide;
  setField<K extends keyof SlideUpdatePayload>(
    key: K,
    value: SlideUpdatePayload[K],
  ): void;
  flush(): void;
}

export function OpenerForm({ draft, setField, flush }: OpenerFormProps) {
  return (
    <div data-testid="layout-form-opener">
      <LayoutHint title="Opener slide">
        Single-statement title plus optional <code>&lt;h2&gt;</code> kicker.
        Renders with the Flexcompute + Thread logo lockup automatically.
      </LayoutHint>
      <CommonSlideFields draft={draft} setField={setField} flush={flush} />
      <TextArea
        label="Body HTML (kicker / subhead)"
        value={draft.bodyHtml}
        onChange={(v) => setField("bodyHtml", v)}
        onBlur={flush}
        rows={8}
        testId="slide-body-html-input"
      />
    </div>
  );
}
